module.exports = __webpack_public_path__ + "img/title-bg.ba02ff33.png";